/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


//       $(document).ready(function(){
//         var datacountdesktop = $(".ProductListWrapper .ProductList").attr("data-desktop-count");
//         var datacountmobile = $(".ProductListWrapper .ProductList").attr("data-mobile-count");
        
//         $('select[name="products per name"] > [value="'+datacountdesktop+'"]').attr("selected", "true");
// 		$('select[name="products per name"]').val(datacountdesktop).change();        
       
      
      	
//       });


		$(document).on('change', 'select[name="products per name"]', function() {
          $('option:selected', 'select[name="products per name"]').removeAttr('selected');
          $('select[name="products per name"] option:selected').attr("selected",true);
//   $('select[name="products per name"]').change(function() {            
            //console.log("clicked");
//             console.log(datacountdesktop);
            var conceptName = $(this).find(":selected").val();
          
              //console.log(conceptName);
            if(conceptName=="2items"){
                $(".custom-two-items-per-row").trigger('click');
            }
            if(conceptName=="3items"){
                $(".custom-four-items-per-row").trigger('click');
            }
        });
 
      
     $(document).on('click','.ColorSwatchList li',function(){
          var targetele = $(this);
          setTimeout(function(){
              if(targetele.find('input').is(':checked')){
                  $('.ColorSwatchList li').removeClass('active__swatch');
                  targetele.addClass('active__swatch');
              }
          },300);
      });  

	
//ZM
 $('body').on('change','.ProductItem__ColorSwatchList input',function(){
   //refresh soldouts
   let _this1 = this
   let color = $(this).val()
   let productInfo = JSON.parse($(this).closest('.ProductItem__Wrapper').find('[data-product-json]').html())
   productInfo = productInfo.product
   if(productInfo.options.length==2){
     let isColorFirst = false
     if(productInfo.options[0].indexOf('olor')>-1){
     	isColorFirst = true
     }else{
     	isColorFirst = false
     }
     $('.Quick-View__Sizes .ProductItem__SizeSwatchItem ').removeClass('soldout')
     $('.Quick-View__Sizes input ').attr('disabled',false)
     productInfo.variants.forEach(function (variant) {
       if(isColorFirst){
         if(variant.option1 == color && !variant.available){
            $(_this1).closest('.ProductItem__Wrapper').find(`.SizeSwatch__Radio[value="${variant.option2}"]`).attr('disabled',true)
           $(_this1).closest('.ProductItem__Wrapper').find(`.SizeSwatch__Radio[value="${variant.option2}"]`).parent().addClass('soldout')
         }
       }else{
         if(variant.option2 == color && !variant.available){
            $(_this1).closest('.ProductItem__Wrapper').find(`.SizeSwatch__Radio[value="${variant.option1}"]`).attr('disabled',true)
         	$(_this1).closest('.ProductItem__Wrapper').find(`.SizeSwatch__Radio[value="${variant.option1}"]`).parent().addClass('soldout')
         }
       }
     })
   }
  let a = $(this).closest('.home-ProductItem__Info').siblings('.ProductIMageWrapper').find(`input[value="${$(this).val()}"]`)
 	$(a)[0].checked = true
    $(this).closest('.home-ProductItem__Info').find('.ProductItem__ColorDefault').text($(a)[0].defaultValue)
    var event = new Event('change', { bubbles: true });
   $(a)[0].dispatchEvent(event)
  });

$(document).ready(function(){
  $('#gift_checkbox').change(function() {
      $('.giftnote-wrap').toggleClass("open");            
  });
  
  if($('body.template-collection').length){
    $('.SectionHeader__Description.Rte img').each(function(){
      $(this).parent().parent().css('max-width','100%').css('width','100%');
      $(this).parent().css('max-width','100%').css('width','100%');
    });
  }
  
  $('.popup-overlay').on('click', function(e) {
    if (e.target !== this)
      return;

    $('.popup-close').trigger('click');
  });
  
//   $('.Header__MainNav ul > li.HorizontalList__Item').each(function(){
//       var navmenu = $(this);
//       if(navmenu.find('.MegaMenu').length){
//           var whichitem = navmenu.index()+1;
//           var mmcontent = navmenu.find('.MegaMenu').html();
//           var targetele = $('.Drawer__Main nav.SidebarMenu__Nav.SidebarMenu__Nav--primary > div:nth-child('+whichitem+')');
//           targetele.addClass('hasmegamenu').append(mmcontent);
//       }
//   });

});


$('.modal-view').click(function(){
    var model_name = $(this).attr('data-model').split(",");
    $('.Product__SlideshowNav').find('.Product__SlideshowNavImage').each(function(){
        var alttext = $(this).find('img').attr('alt');
        $(this).removeClass('is-selected');
        if(jQuery.inArray(alttext, model_name) == -1){
			console.log(alttext);	
            $(this).addClass("is-none");
          	$(this).removeClass("is-show");
        }else{
          $(this).addClass("is-show"); 
          $(this).removeClass("is-none");
		}
    });
  $('.Product__SlideshowNav').find('.Product__SlideshowNavImage.is-show').first().addClass('is-selected').find('img').trigger('click');
});

if($('.active__swatch').length){
let _this1 = $('.active__swatch').find('label')
var model_name = '#'+($(_this1).attr('data-tooltip'));
  var hasvariant_img =  false;
  $('.Product__SlideshowNav').find('.Product__SlideshowNavImage').each(function(){
	var alttext = $(this).find('img').attr('alt');
    $(this).removeClass('is-selected');
// 	$(this).removeClass("is-none");
    if(alttext != model_name){      
      $(this).addClass("is-none");
      $(this).removeClass("is-show");
	  $(this).removeClass('is-selected');
    }else{
      $(this).addClass("is-show"); 
      $(this).removeClass("is-none");
      hasvariant_img = true;
    }
    
  });

  if ($(window).width() > 500) {
  
  $('.Product__Slideshow').find('.Product__SlideItem').each(function(){
	var alttext = $(this).find('img').attr('alt');
    $(this).removeClass('is-selected');
// 	$(this).removeClass("is-none");
    if(alttext != model_name){      
      $(this).addClass("is-none");
      $(this).removeClass("is-show");
	  $(this).removeClass('is-selected');
    }else{
      $(this).addClass("is-show");
      $(this).removeClass("is-none");
      hasvariant_img = true;
    }
    
  });

}
  
  setTimeout(function(){
  		$('.Product__SlideshowNav').find('.Product__SlideshowNavImage.is-show').first().addClass('is-selected').find('img').trigger('click');
    }, 100);
  if(!hasvariant_img){
    $('.Product__SlideshowNav').find('.Product__SlideshowNavImage').each(function(){
    	$(this).removeClass("is-none");
    });
  }

  var isShow = $(".is-show").length;
  if (isShow == 1){
    $(".thumbnail-custom-div").hide();
    $("div#shopify-section-product-template .custom-for-photo").addClass("full-width");
  }
  else{
    $(".thumbnail-custom-div").show();
    $("div#shopify-section-product-template .custom-for-photo").removeClass("full-width");
  }
}

$('.ColorSwatchList .ColorSwatch').click(function(){
  var model_name = '#'+($(this).attr('data-tooltip'));
  var hasvariant_img =  false;
  $('.Product__SlideshowNav').find('.Product__SlideshowNavImage').each(function(){
	var alttext = $(this).find('img').attr('alt');
    $(this).removeClass('is-selected');
// 	$(this).removeClass("is-none");
    if(alttext != model_name){      
      $(this).addClass("is-none");
      $(this).removeClass("is-show");
	  $(this).removeClass('is-selected');
    }else{
      $(this).addClass("is-show"); 
      $(this).removeClass("is-none");
      hasvariant_img = true;
    }
    
  });

  if ($(window).width() > 500) {
  

  $('.Product__Slideshow').find('.Product__SlideItem').each(function(){
	var alttext = $(this).find('img').attr('alt');
    $(this).removeClass('is-selected');
// 	$(this).removeClass("is-none");
    if(alttext != model_name){      
      $(this).addClass("is-none");
      $(this).removeClass("is-show");
	  $(this).removeClass('is-selected');
    }else{
      $(this).addClass("is-show");
      $(this).removeClass("is-none");
      hasvariant_img = true;
    }
    
  });

  }
  
  setTimeout(function(){
  		$('.Product__SlideshowNav').find('.Product__SlideshowNavImage.is-show').first().addClass('is-selected').find('img').trigger('click');
    }, 100);
  if(!hasvariant_img){
    $('.Product__SlideshowNav').find('.Product__SlideshowNavImage').each(function(){
    	$(this).removeClass("is-none");
    });
  }

  var isShow = $(".is-show").length;
  if (isShow == 1){
    $(".thumbnail-custom-div").hide();
    $("div#shopify-section-product-template .custom-for-photo").addClass("full-width");
  }
  else{
    $(".thumbnail-custom-div").show();
    $("div#shopify-section-product-template .custom-for-photo").removeClass("full-width");
  }
});

// $('li.HorizontalList__Item').click(function(){
//   var model_name = $('li.HorizontalList__Item').find('input.ColorSwatch__Radio').val();
//   console.log(model_name);
//   $('.Product__SlideshowNav').find('.Product__SlideshowNavImage').each(function(){
//     var alttext = $(this).find('img').attr('alt');
// 	$(this).removeClass('is-selected');
//         if(jQuery.inArray(alttext, model_name) == -1){
// 			console.log(alttext);	
//             $(this).addClass("is-none");
//           	$(this).removeClass("is-show");
//         }else{
//           $(this).addClass("is-show"); 
//           $(this).removeClass("is-none");
// 		}
//   });
//   $('.Product__SlideshowNav').find('.Product__SlideshowNavImage.is-show').first().addClass('is-selected').find('img').trigger('click');
// });


$('button.announcement-bar__close').click(function(){
$('#section-announcement').hide();
});
$('[data-filter-mobile-toggle]').on('click',function(){
  let $ele =  $(this).siblings('.CollectionFilters__DIV')
  if($ele.height()==0){
      $ele.animate({
        height: $(this).siblings('.CollectionFilters__DIV').get(0).scrollHeight
    }, 800, function(){
         $(this).height('auto');
    });
  }else{
    $ele.animate({
        height: 0
    }, 800, function(){
    //     $(this).height('auto');
    });
  }
});


$(document).on('click','span.note-exit',function(){
  $('.Cart__OffscreenNoteContainer').attr('aria-hidden',true);
});

$(document).ready(function(){
  if($('.CollectionFilters').length){
    $('.CollectionFilters > div').each(function(){
      var filterele = $(this);
      if(!filterele.hasClass('collection_list-filter')){
        if(filterele.find('ul.Linklist li.is-selected a').html() != 'All'){
          var hasfilterselected = filterele.find('ul.Linklist li.is-selected').length;
          if(hasfilterselected){
            $('a.top-reset-filter').show();
            return false; //break
          } 
        }
      }
    });
  }
});



$('#footer-newsletter').on('focusin', function(){
  $(this).find('[type="email"]').attr('data-placeholder', $(this).find('[type="email"]').attr('placeholder'));
  
  $(this).find('[type="email"]').attr('placeholder', '');
 //console.log( $(this).find('[type="email"]'));

}).on('focusout', function(){
   $(this).find('[type="email"]').attr('placeholder',  $(this).find('[type="email"]').attr('data-placeholder'));
  
});



// Yotpo Override 
    
$(document).ready(function() {

setTimeout(function(){
      $('.bottom-line-items-container-mobile').css('margin','0');
  	  $("label[for*='yotpo_input_question_username']").html("<span class='yotpo-mandatory-mark'>* </span>Name: <span class='form-input-error yotpo-hidden'></span>");
},1000);   
  
});
 


/* Terms and Conditions Register Account */
    
      $(document).ready(function() {
    $('body').on('click', '[name="sign-up-account"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to sign up.");
        return false;
      }
    });
  });
        
// Search Bar Page Overlay Clickout

$(document).ready(function() {    
    
    
$('.PageOverlay').on('click', function(){
    
if ( $('#Search').attr('aria-hidden') == 'false' ) {
   $('#Search').attr('aria-hidden', 'true');
   $('.PageOverlay').removeClass('is-visible');
   $('html').removeClass('no-scroll');
}   
    
});    

});
    
   
    
// New Filter Drawer on PLP
    
$(document).ready(function() {    
    
  $('.nn-filter-button').on('click', function(){
    $('.CollectionInner__Sidebar.CollectionInner__Sidebar--withTopToolbar.hidden-pocket').addClass('active');
    $('html').addClass('no-scroll');
    $('.PageOverlay').addClass('is-visible');
  });
    
  $('.pfhh-close').on('click', function(){
    $('.CollectionInner__Sidebar.CollectionInner__Sidebar--withTopToolbar.hidden-pocket').removeClass('active');
    $('html').removeClass('no-scroll');
    $('.PageOverlay').removeClass('is-visible');
  });
  
  	var filterBox = $('.CollectionInner__Sidebar.CollectionInner__Sidebar--withTopToolbar.hidden-pocket');  

    
    
    	$('.PageOverlay').on('click', function(){
    		if ( $('.CollectionInner__Sidebar.CollectionInner__Sidebar--withTopToolbar.hidden-pocket').hasClass('active')){
    			$(this).removeClass('is-visible');
    			 $('.CollectionInner__Sidebar.CollectionInner__Sidebar--withTopToolbar.hidden-pocket').removeClass('active');
    			$('html').removeClass('no-scroll');
    		}
    
    		
    	}); 
});

// Scrolling for sticky nav
$(document).ready(function() {
    checkScroll();

    $(window).on('scroll', checkScroll);
});

function checkScroll() {
    if ($(window).scrollTop() > 0) {
        $('.mm-ocd').addClass('scrolling');
    } else {
        $('.mm-ocd').removeClass('scrolling');
    }
}


$(window).on('resize', function() {
    var width = $(window).width();
    if (width < 440) {
        $('#shopify-section-product-template .review-wrap .yotpo-bottomline .text-m').each(function() {
            var text = $(this).text();
            if (!text.startsWith('(')) {
                var number = text.replace('Reviews', '').trim();
                $(this).text('(' + number + ')');
            }
        });
    }
}).resize();


if ($(".qty-addtocart-wrapper").length) {
 $(window).scroll(function() {
    var button = $('.qty-addtocart-wrapper');
    var targetDiv = $('.pdp-under-product-messages');
    
    var targetDivTop = targetDiv.offset().top;
    var targetDivHeight = targetDiv.outerHeight();
    var windowHeight = $(window).height();
    var windowScrollTop = $(window).scrollTop();

    var highlightPrice = $('.ProductMeta__PriceList .Price--highlight').text();
    var compareAtPrice = $('.ProductMeta__PriceList .Price--compareAt').text();
  
      var priceHTML = '';
  
      if (highlightPrice && compareAtPrice) {
          priceHTML = `<s>${compareAtPrice}</s> ${highlightPrice}`;
      } else {
          priceHTML = $('.ProductMeta__PriceList').text();
      }

    var title = $('.ProductMeta__Title').text();

    if (windowScrollTop + windowHeight > targetDivTop && windowScrollTop < targetDivTop + targetDivHeight) {
        button.removeClass('sticky-button');
        button.find('span').text(`Add to bag`);
       
    } else {
        button.addClass('sticky-button');
        button.find('span').html(`${title} ${priceHTML}`);
    }
}); 
}

jQuery(function($) {
  // Function to check for the selected color and update the display
  function updateColorDisplay() {
    var colorValue = $('.HorizontalList__Item.active__swatch input').val() || '';

    $('.Rte').hide();

    var colorDivs = $('#colorDescription div:not(.metafield-rich_text_field)').hide();

    var matchedDiv = $('#colorDescription div[data-color="' + colorValue + '"]');
    if(matchedDiv.length > 0) {
      matchedDiv.show();
    } else {
      $('.Rte').show();
    }
  }

  $('.ColorSwatchList li input').click(function() {
    setTimeout(updateColorDisplay, 500);
  });

  updateColorDisplay();
});

function checkElement() {
    var element = $('.open-filters-toggle'); // Change 'your-element-id' to the ID of your element
    if (element.length) {
      var jQueryObject = $('.open-filters-toggle');
      var rawDOMElement = jQueryObject.get(0);
      var eventObject = $._data(rawDOMElement, 'events');

      if (eventObject != undefined && eventObject.click != undefined) {
        //element already has click event
      } else {
        // If the element exists, apply the onclick event handler
        element.on('click', function() {
          $('.filter-box').slideToggle('slow', function() {
            $('.CollectionMain .ProductListWrapper').toggleClass('filters-active');
          });
        });
      }
    } else {
        // If the element doesn't exist, wait for a short delay and check again
        setTimeout(checkElement, 1000); // Change the delay (in milliseconds) as needed
    }
}





$(document).ready(function() {
    $('.search-icon').on('click', function() {
        if ($('#rebuy-quick-view-dropdown-search').length) {
            console.log('Rebuy search is present');
            $('#Search').hide();
        }
    });

        if ($('body').hasClass('template-search')) {
        // Function to hide the element with data-section-id="search"
        function hideSearchSection() {
            $('[data-section-id="search"]').hide();
        }

        // Check if the #rebuy-smart-search-results-dropdown already exists
        if ($('#rebuy-smart-search-results-dropdown').length) {
            hideSearchSection();
        } else {
            // Use MutationObserver to watch for changes in the DOM
            var observer = new MutationObserver(function(mutationsList, observer) {
                mutationsList.forEach(function(mutation) {
                    if (mutation.type === 'childList') {
                        // Check again if the #rebuy-smart-search-results-dropdown has appeared
                        if ($('#rebuy-smart-search-results-dropdown').length) {
                            hideSearchSection();
                            // Stop observing once the element is found
                            observer.disconnect();
                        }
                    }
                });
            });

            // Start observing the body for changes
            observer.observe(document.body, { childList: true, subtree: true });
        }
    }
});

$(document).ready(function() {
  if ($('.new-collection-filters-old').length) {
    console.log('found');
    $('.new-collection-filters-old .filter-toggle').on('click', function() {
      console.log('clicked');
      $('.new-collection-filters-old .filters').slideToggle();
    });
  }
});
